import React, { useState, useRef, useEffect } from 'react'
import { completeQACheck } from 'actions'
import { partnerHostStaging, partnerHostLive } from '../../../../../constants'
import { Button } from 'react-bootstrap'
import { withRouter, useParams } from 'react-router'
import Webcam from 'react-webcam'
import { connect } from 'react-redux'

const Host = window.location.hostname

const QAPhotoCaptureScreen = ({ history, completeQACheck }) => {
  const { token, bookingId } = useParams()

  const webcamRef = useRef(null)
  const [step, setStep] = useState(1)
  const [chauffeurPhoto, setChauffeurPhoto] = useState(null)
  const [chauffeurPhotoBase64, setChauffeurPhotoBase64] = useState('')
  const [vehiclePhoto, setVehiclePhoto] = useState(null)
  const [vehiclePhotoBase64, setVehiclePhotoBase64] = useState(null)

  const capture = () => {
    const imageSrc = webcamRef.current.getScreenshot()
    if (!imageSrc) return

    if (step === 1) {
      setChauffeurPhoto(imageSrc)
      setStep(2)
    } else if (step === 3) {
      setVehiclePhoto(imageSrc)
      setStep(4)
    }
  }

  const handleUsePhoto = async () => {
    if (step === 2) {
      setStep(3)
    } else if (step === 4) {
      const data = {
        chauffeurPhoto: chauffeurPhoto,
        vehiclePhoto: vehiclePhoto,
      }
      try {
        await completeQACheck(data, bookingId)

        setTimeout(
          async function() {
            history.replace(
              `${
                Host === partnerHostLive || Host === partnerHostStaging
                  ? '/'
                  : '/partner/'
              }driver/app/details/${token}/${bookingId}`
            )
          }.bind(this),
          1500
        )
      } catch (error) {
        console.error(error)
        alert('Submission failed')
      }
    }
  }

  const handleRetake = () => {
    if (step === 2) setStep(1)
    if (step === 4) setStep(3)
  }

  const renderOverlayText = () => {
    if (step === 1)
      return [
        'Take a selfie',
        'Make sure your face is centered in the frame and clearly visible.',
      ]
    if (step === 3)
      return [
        'Rotate your phone',
        'Take the photo in landscape mode for a clearer view.',
      ]
    return []
  }

  return (
    <div className='qa-photo-container'>
      {(step === 1 || step === 3) && (
        <>
          <div className='camera-container'>
            <Webcam
              ref={webcamRef}
              screenshotFormat='image/jpeg'
              mirrored={step === 1}
              className='camera-feed'
              videoConstraints={{
                facingMode: step === 1 ? 'user' : 'environment',
              }}
            />
            {(step === 1 || step === 3) && (
              <div className='mask'>
                {step === 1 && <div className='oval' />}
                {step === 3 && <div className='rectangle' />}

                {step === 3 ? (
                  <>
                    <div className='rotate-text'>
                      <h2>{renderOverlayText()[0]}</h2>
                      <p>{renderOverlayText()[1]}</p>
                    </div>
                  </>
                ) : (
                  <div className='camera-text'>
                    <h2>{renderOverlayText()[0]}</h2>
                    <p>{renderOverlayText()[1]}</p>
                  </div>
                )}

                <button className='capture-button' onClick={capture} />
              </div>
            )}
          </div>
        </>
      )}

      {(step === 2 || step === 4) && (
        <div className='qa-instructions-container'>
          <div>
            <img
              className='driver-back-icon-qa mx-50%'
              src='/images/icon-back.png'
              onClick={e => {
                e.preventDefault()
                window.history.back()
              }}
              alt='Back'
            />
          </div>
          <div className='qa-content-block'>
            <h2 className='qa-heading'>
              Upload your {step === 2 ? '' : "vehicle's"} photo
            </h2>
            <img
              src={step === 2 ? chauffeurPhoto : vehiclePhoto}
              alt='Preview'
              className='preview-img'
            />
            <p className='preview-text'>
              {step === 2
                ? 'Take a clear photo of yourself wearing the required dress code.'
                : 'Take a clear photo of your vehicle’s interior, ensuring all required amenities are visible.'}
            </p>
          </div>
          <div className='driver-booking-cta-footer'>
            <Button
              className='select-btn select-vehicle mb-2'
              style={{
                width: '100%',
                fontWeight: '900',
                fontSize: '16px',
                textShadow: '0.25px 0 #ffffff',
              }}
              variant='brown'
              onClick={handleUsePhoto}
            >
              Use this photo
            </Button>

            <Button
              className='select-btn select-vehicle-outline'
              style={{
                width: '100%',
                fontWeight: '900',
                fontSize: '16px',
                textShadow: '0.25px 0 #ffffff',
                backgroundColor: 'white',
                color: '#a79779',
                border: '1px solid #a79779',
              }}
              variant='outline'
              onClick={handleRetake}
            >
              Retake photo
            </Button>
          </div>
        </div>
      )}
    </div>
  )
}

export default withRouter(
  connect(null, {
    completeQACheck,
  })(QAPhotoCaptureScreen)
)
